import { useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import DateSelect from "../XoSoSidebar/DateSelect";
import useDienToan6x36 from "../DienToan6x36/useDienToan6x36";
import { PRODUCT, TZ } from "../DienToan6x36/constants";
import CompactResult from "./CompactResult";
import "../XoSoSidebar/XoSoSidebar.css";
import "./SidebarDienToan6x36.css";

dayjs.extend(utc);
dayjs.extend(timezone);

function SidebarDienToan6x36({ defaultDate, dataDefault, config }) {
  const today = dayjs().tz(TZ).format("YYYY-MM-DD");
  const [date, setDate] = useState(defaultDate || dataDefault || config?.date || null);
  const { results, loading, resolvedDate } = useDienToan6x36(date, 1);
  const selectedDate = date || resolvedDate || today;

  return (
    <div className="xoso-sidebar dt636-sidebar">
      <div className="xoso-sidebar__head">
        <div className="xoso-sidebar__title">
          KQXS <span>{PRODUCT}</span>
        </div>
        <DateSelect value={selectedDate} onChange={setDate} maxDate={today} />
      </div>
      <CompactResult result={results[0]} date={selectedDate} loading={loading} />
    </div>
  );
}

SidebarDienToan6x36.DateSelect = DateSelect;
SidebarDienToan6x36.Result = CompactResult;

export { DateSelect, CompactResult };
export default SidebarDienToan6x36;
